import {getValueFromObjectByPrefix, languagesMenu, menuFromData} from '../utils';
import {domains, languages} from './../data/constants.json';
import {modifyLangOnlyLinks, modifyLinks} from './common';
import * as cssMobile from './header/mobile.scss';
import * as cssDesktop from './header/desktop.scss';
import htmlMobile from './header/mobile';
import htmlDesktop from './header/desktop';
import iconGlobe from './svg/globe';
import iconLogout from './svg/logout';
import iconArrowRight from './svg/arrowRight';
import {headerMenuData} from '../data/header';

export default ({translations, isMobile, user, config, location = null}) => {
  const t = getValueFromObjectByPrefix(translations);

  const mainLinks = menuFromData(
    isMobile ? headerMenuData.mobileNav : headerMenuData.nav,
    translations,
    config.language,
    [modifyLangOnlyLinks, modifyLinks(user)],
  );

  const userLinks = menuFromData(headerMenuData.userNav, translations, config.language);

  if (user && !isMobile) {
    mainLinks.unshift({
      href: `https://${domains.wix}/my-account`,
      text: t('menu_my_account'),
      contentAttrs: {
        'data-hook': 'menu_my_account'
      }
    });
  }

  if (isMobile) {
    mainLinks.push({
      extraContent: `<i data-hook="globe-icon" class="${cssMobile.icon} ${cssMobile.iconInlineGlobe}">${iconGlobe}</i>${languages[config.language].origin}<i data-hook="icon-right" class="${cssMobile.icon} ${cssMobile.iconInlineArrowRight} ${cssMobile.iconToRight}">${iconArrowRight}</i>`,
      tag: 'button',
      classes: user ? cssMobile.divider : null,
      contentClasses: cssMobile.button,
      contentAttrs: {
        'data-switch-to': cssMobile.languagesOpen,
        'data-bi': '203:name=Change language',
        tabindex: config.tabIndex[0],
        role: 'menuitem',
        'aria-label': t('choose_language'),
        'data-hook': 'languages',
      }
    });
    mainLinks.forEach(link => {
      if (link.important) {
        link.classes = cssMobile.important;
      }
    });

    if (user) {
      mainLinks.unshift({
        href: `https://${domains.wix}/my-account`,
        text: t('menu_my_account'),
        contentAttrs: {
          id: `${cssMobile.menuOpen}-label`,
          'data-hook': 'my-account-link',
        }
      });

      mainLinks.push({
        href: `https://${domains.wix}/signout`,
        text: t('logout'),
        extraText: `<i data-hook="logout-icon" class="${cssMobile.icon} ${cssMobile.iconInlineLogout}">${iconLogout}</i>`,
        contentAttrs: {
          'data-hook': 'logout',
        }
      });
    }
  }

  userLinks.push({
    tag: 'button',
    text: languages[config.language].origin,
    subs: languagesMenu(config.supportedLanguages.filter(language => config.language !== language), location, config),
    extraContent: `<i data-hook="globe-icon" class="${cssDesktop.icon} ${cssDesktop.iconGlobe}"></i>`,
    classes: cssDesktop.hasDropdown,
    attrs: {
      rel: 'languages',
    },
    contentAttrs: {
      'data-hook': 'languages',
    }
  });

  userLinks.push({
    href: `https://${domains.wix}/signout`,
    text: t('logout'),
    contentAttrs: {
      'data-hook': 'logout'
    }
  });

  return `
  <div style="visibility: hidden; z-index: 9999; display: ${config.hideHeader ? 'none' : 'flex'}" class="${isMobile ? cssMobile.container : cssDesktop.container}" data-hook="wix-header-container">
    ${{true: htmlMobile, false: htmlDesktop}[isMobile]({mainLinks, userLinks, user, t, config, location, isMobile})}
  </div>`;
};
